<template>
  <div class="page">
    <div class="m-bg-cover"></div>
    <div class="m-content">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <!-- 下拉刷新 -->
        <van-pull-refresh
            v-model="isLoading"
            success-text="刷新成功"
            @refresh="onRefresh"
        >
          <div class="m-box" v-for="(item,index) in dataList" :key="item.id">
            <!--遮盖层-->
            <!--<div v-if="true||item.status==2" class="m-cover-box"><p>报名结束</p></div>-->
            <div class="m-top-title x-flex-between" @click="goDetail(item)">
              <div>
                <p class="m-des">{{item.name}}</p>
              </div>
              <van-icon class="m-right" name="arrow"/>
            </div>
            <div class="m-tab">
              <van-tag v-if="item.userRegisterStatus==0&&item.hasPayment==1&&item.payStatus!=5" class="m-tag" color="#FFF0DE" size="medium" text-color="#F19E3B">未支付</van-tag>
              <van-tag v-if="item.userRegisterStatus==0&&item.hasPayment==1&&item.payStatus==5" class="m-tag" color="#FFE8E8" size="medium" text-color="#F13C3A">缴费处理中</van-tag>
              <van-tag v-if="item.userRegisterStatus==1&&item.hasOfflinePay!=1" class="m-tag" color="#EBF1FF" size="medium" text-color="#457DF9">报名成功</van-tag>
              <van-tag v-if="item.userRegisterStatus==1&&item.hasOfflinePay==1" class="m-tag" color="#EBF1FF" size="medium" text-color="#457DF9">报名成功</van-tag>
              <van-tag v-if="item.userRegisterStatus==4&&item.hasOfflinePay==1" class="m-tag" color="#EBF1FF" size="medium" text-color="#457DF9">已报名</van-tag>
              <van-tag v-if="item.userRegisterStatus==5&&item.hasOfflinePay==1" class="m-tag" color="#EBF1FF" size="medium" text-color="#457DF9">报名不通过</van-tag>
              <van-tag v-if="item.userRegisterStatus==2" class="m-tag" color="#FFF0DE" size="medium" text-color="#F19E3B">未审核</van-tag>
              <van-tag v-if="item.userRegisterStatus==3" class="m-tag" color="#FFE8E8" size="medium" text-color="#F13C3A">审核失败</van-tag>
              <van-tag v-if="item.userRegisterStatus==0&&item.examineStatus==1" class="m-tag" color="#EBF1FF" size="medium" text-color="#457DF9">审核通过</van-tag>
            </div>
            <div class="m-center">
              <div class="m-nav">
                <span>考试科目</span>
                <p class="ellipsis">{{item.useExamSubjectName || ''}}</p>
              </div>
              <div v-if="item.openStartTime&&item.openEndTime" class="m-nav">
                <span>报名时间</span>
                <p>{{item.openStartTime+ ' -'}}  {{item.openEndTime}}</p>
              </div>
              <div v-if="item.paymentStartTime&&item.paymentEndTime&&item.hasPayment==1" class="m-nav">
                <span>缴费时间</span>
                <p>{{item.paymentStartTime+ ' -'}} {{item.paymentEndTime}}</p>
              </div>
              <div v-if="item.admissionPrintTimeSt&&item.admissionPrintTimeEd" class="m-nav">
                <span>准考证打印时间</span>
                <p>{{item.admissionPrintTimeSt+ ' -'}} {{item.admissionPrintTimeEd}}</p>
              </div>
            </div>
            <!--<div v-if="item.userRegisterStatus!=1&&item.status!=2" class="m-footer">-->
              <!--<van-button size="normal"  v-if="item.hasNeedNameAccess==1&&item.hasNameAccess!=1" block @click="goTo(item,'/uploadCard')" class="m-btn m-width">实名认证</van-button>-->
              <!--<van-button size="normal" v-if="item.examineStatus!=1&&item.userRegisterStatus!=2" block @click="goTo(item,'/examInfo',2)" class="m-btn m-width1">修改报考信息</van-button>-->
              <!--<van-button size="normal" v-if="item.hasPayment==1&&item.userRegisterStatus==0" block @click="goTo(item,'/examPay',3)" class="m-btn m-width2">去支付</van-button>-->
            <!--</div>-->
            <div v-if="item.userRegisterStatus==1" class="m-footer">
              <!--<van-button size="normal" v-if="item.status!=2&&item.hasPayment!=1" block @click="goTo(item,'/examInfo',2)" class="m-btn m-width1">修改报考信息</van-button>-->
              <van-button size="normal" v-if="item.hasAccessAdmission==1" block @click="goNote(item)" class="m-btn m-width3">准考证打印</van-button>
              <van-button size="normal" v-if="item.hasShowScore==1" block @click="goAchieve(item)" class="m-btn m-width4">成绩查询</van-button>
            </div>
          </div>
        </van-pull-refresh>
      </van-list>
    </div>
    <!--弹出退出确认框-->
    <van-popup v-model="show" round get-container="body">
      <div class="m-popup">
        <div class="m-title">是否下载准考证</div>
        <div class="m-chose">
          <p @click="show=false">取消</p>
          <p @click="getDown()">
            确定
          </p>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  export default {
    components: {},
    data () {
      return {
        pageNum: 1,
        pageSize: 5,
        count: 0,
        loading: false,
        finished: false,
        isLoading: true,
        dataList: [],
        title:'',
        hrefUrl:'',
        show: false,
        setId:'',
        token:window.localStorage.getItem('token'),
        people:{}
      }
    },
    created () {
      this.getInfo()
    },
    methods: {
      ...mapMutations({
        SET_ENROLL_KEY: 'enroll/setEnrollKey'
      }),
      onLoad () {
        if (this.isLoading) {
          this.isLoading = false
        } else {
          this.pageNum++
        }
        this.getList()
      },
      onRefresh () {
        this.loading = true
        this.dataList = []
        this.pageNum = 1
        this.onLoad()
      },
      getList (bol) {
        this.http.getRequest({
          url: 'app/exam/findList',
          msg: {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
            mineReport: true
          },
          success: (res) => {
            this.count = res.total
            this.dataList = this.dataList.concat(res.rows)
            this.loading = false
            if (this.dataList.length >= this.count) {
              this.finished = true
            }else {
              this.finished = false
            }
          }
        })
      },
      goTo (i, y,z) {                       
        if(i.status==2){
          this.utils.toastNone('报名已经结束！')
          return
        }
        if(z>1&&i.hasNeedNameAccess==1&&i.hasNameAccess!=1){
          this.utils.toastNone('请先完成实名认证！')
          return
        }
        if(z==3){
          this.http.getRequest({
            url:`app/exam/findExamInfoSubmit/${i.id}`,
            msg:{},
            success:(res)=>{
              if(res.data+''=='true'){
                this.SET_ENROLL_KEY({key: 'configItem', value: i})
                this.$router.push({
                  path: y,
                  query:{
                    id:i.id
                  }
                })
              }else {
                this.utils.toastNone('请完善报考信息！')
              }
            }
          })
        }else {
          this.SET_ENROLL_KEY({key: 'configItem', value: i})
          this.$router.push({
            path: y,
            query:{
              id:i.id
            }
          })
        }
      },
      goNote(i){
        if(i.hasNeedNameAccess==1){
          if(this.people.hasNameAccess!=1){
            this.utils.toastNone('此账号为未实名或已过期的状态，请去个人中心实名认证！')
            return
          }
        }
        this.http.getRequest({
          url:`app/exam/findRegisterInfo/${i.id}`,
          msg:{},
          success:(res)=>{
            let data = res.data
            if(data.register&&data.register.hasReadAdmissionNotice==1){
              this.$router.push({
                path:'/notes',
                query:{
                  examId:i.id
                }
              })
            } else {
              this.getBol(i.id)
            }
          }
        })
      },
      getBol(id){
        this.show = true
        this.setId = id
      },
      getDown(){
        window.open(`/api/app/exam/downLoadAdmission/${this.setId}?token=${this.token}`)
        this.show = false
      },
      goDetail(i){
        this.SET_ENROLL_KEY({key: 'configItem', value: i})
        this.$router.push({
          path: '/enrollDetail',
          query:{
            detailId:i.userRegisterId
          }
        })
      },
      //成绩公示
      goAchieve(i){
        this.http.getRequest({
          url:`app/exam/findRegisterInfo/${i.id}`,
          msg:{},
          success:(res)=>{
            let register = res.data&&res.data.register ? res.data.register : {}
            if(res.data&&res.data.register&&res.data.register.publicType==1){
              this.$router.push({
                path: '/publicity',
                query:{
                  id:i.id
                }
              })
            }else {
              if(register.hasReadGradeNotice==1){
                this.$router.push({
                  path: '/notes',
                  query:{
                    historyId:i.id
                  }
                })
              }else {
                this.$router.push({
                  path: '/publicity',
                  query:{
                    id:i.id
                  }
                })
              }
            }
          }
        })
      },
      //    获取个人信息
      getInfo(){
        this.http.postRequest({
          url: 'app/user/getUserInfo',
          msg: {},
          success: (res) => {
            this.people = res.data
          }
        })
      },
    },
    mounted () {
      
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  @import "~@/assets/css/variable.less";

  .page {
    background: #F4F6F9;
    .m-bg-cover {
      position: absolute;
      width: 100%;
      height: 180px;
      background: linear-gradient(360deg, #F4F6F9 0%, #2B6CF9 28%, #2B6CF9 100%);
      z-index: -1;
    }
    .m-content {
      padding: 30px 12px 15px 12px;
      .m-box {
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        overflow: hidden;
        margin-bottom: 15px;
        padding: 20px 12px;
        position: relative;
        .m-cover-box{
          position: absolute;
          border-radius: 4px 4px 4px 4px;
          left: 0;
          right: 0;
          top:0;
          bottom: 0;
          background: rgba(111,111,111,0.3);
          z-index: 100;
          display: flex;
          align-items: center;
          justify-content: center;
          >p{
            text-align: center;
            line-height: 26px;
            width: 80px;
            height: 26px;
            background: #ffffff;
            border-radius: 13px;
            color: #AAAAAA;
            font-size: 14px;
          }
        }
        .m-top-title {
          > div {
            display: flex;
            align-items: center;
            width: 90%;
            .m-tag {
              margin-right: 5px;
            }
            .m-des {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              flex: 1;
              font-size: 15px;
              font-weight: bold;
            }
          }
          .m-right {
            color: #AAAEB6;
            font-size: 15px;
          }
        }
        .m-tab{
          display: flex;
          align-items: center;
          margin-top: 13px;
          margin-right: 6px;
          .m-tag{
            margin-right: 6px;
          }
        }
        .m-center {
          background: #F9F9F9;
          border-radius: 2px 2px 2px 2px;
          padding: 5px 10px;
          margin-top: 11px;
          .m-nav {
            display: flex;
            /*align-items: center;*/
            line-height: 25px;
            font-size: 12px;
            color: #333333;
            > span {
              display: block;
              margin-right: 15px;
              width: 60px;
            }
            >p{
              flex: 1;
            }
          }
        }
        .m-footer {
          margin-top: 12px;
          display: flex;
          justify-content: flex-end;
          .m-btn {
            margin-right: 14px;
            border-radius: 4px;
            background: #F2F6FF;
            color: #2B6CF9;
            /deep/ .van-button__text {
              font-size: 14px;
              font-weight: bold;
            }
          }
          .m-width{
            width: 100px!important;
          }
          .m-width1{
            width: 129px!important;
          }
          .m-width2{
            width: 100px!important;
            background: #FFF5EA;
            color: #F19E3B;
          }
          .m-width3{
            width: 110px!important;
          }
          .m-width4{
            width: 100px!important;
          }
          /*.m-btn:nth-child(2) {*/
            /*width: 450px;*/
          /*}*/
          .m-btn:last-child {
            margin-right: 0;

          }
        }
      }
    }
  }
  .m-popup {
    width: 300px;
    height: 103px;
    background: #ffffff;
    font-size: 15px;
    overflow: hidden;
    .m-title {
      text-align: center;
      font-size: 15px;
      font-weight: bold;
      height: 53px;
      line-height: 53px;
      border-bottom: 1Px solid #E7E7E7;
    }
    .m-chose {
      display: flex;
      > p {
        flex: 1;
        text-align: center;
        height: 50px;
        line-height: 50px;
        font-size: 15px;
        font-weight: bold;
      }
      > p:nth-child(2) {
        color: #2B6CF9;
        border-left: 1Px solid #E7E7E7;
      }
      /*a{*/
        /*display: block;*/
        /*width: 100%;*/
        /*height: 100%;*/
      /*}*/
    }
  }

  .van-popup--center.van-popup--round {
    border-radius: 4px !important;
  }
</style>

